var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"remote-component-container",style:(_vm.containerStyles)},[_c(_vm.currentView,_vm._b({tag:"component",style:({opacity: _vm.componentLoaded ? 1 : 0})},'component',_vm.$props,false)),_vm._v(" "),(!_vm.componentLoaded)?_c('div',{staticClass:"remote-loading"},[_vm._t("loading")],2):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/remote-component/index.vue